module.exports = __webpack_public_path__ + "static/media/holiday_hampers.57f25f90.jpg";